import React from 'react';
import cx from 'classnames';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components';

import { SpinnerNew as Spinner } from '~/App/Components/Shared/Spinner';
import CenteredModal from '~/App/Modules/Testimonials/Components/CenteredModal';
import {
  parseRichTextToString,
  RichText,
  RichTextEditor,
} from '@vimily/bonjoro-ui-components-v2/RichTextEditor';

export interface AddTextAssetModalProps {
  heading: string;
  content?: RichText;
  onSetContent: (content: RichText) => void;
  placeholder?: string;
  open?: boolean;
  loading?: boolean;
  textAreaClassName?: string;
  onSave?: () => void;
  onRequestClose: (e?: React.MouseEvent | React.KeyboardEvent) => void;
}

export default function AddTextAssetModal({
  heading,
  content,
  onSetContent,
  placeholder = '',
  open = false,
  loading = false,
  textAreaClassName,
  onSave,
  onRequestClose,
}: AddTextAssetModalProps) {
  const isEmpty = parseRichTextToString(content ?? []).length === 0;

  return (
    <CenteredModal
      open={open}
      onRequestClose={onRequestClose}
      loading={loading}
      heading={heading}
      width={434}
    >
      <RichTextEditor
        className={cx('!v2-h-64 mb-[30px]', textAreaClassName)}
        placeholder={placeholder}
        onChange={onSetContent}
        value={content}
      />
      <div className='flex justify-end gap-x-4'>
        <Button
          variant={ButtonVariant.Info}
          onClick={onRequestClose}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button onClick={onSave} disabled={loading || isEmpty}>
          Save {loading && <Spinner className='ml-2' />}
        </Button>
      </div>
    </CenteredModal>
  );
}
